export default __webpack_public_path__ + "static/media/logo.b07db3bc.png";